/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Next_TitleInputs */

const en_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next event`)
};

const fr_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller a l'evenement suivant`)
};

const de_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum nächsten Ereignis`)
};

const it_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al prossimo evento`)
};

const ru_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к следующему мероприятию`)
};

const es_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al siguiente evento`)
};

const zh_cn2_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往下一个活动`)
};

const ja_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントへ進む`)
};

const hi_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले कार्यक्रम पर जाएं`)
};

const pt_pt2_video_export_preview_go_to_next_title = /** @type {(inputs: Video_Export_Preview_Go_To_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o próximo evento`)
};

/**
* | output |
* | --- |
* | "Go to next event" |
*
* @param {Video_Export_Preview_Go_To_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_next_title = /** @type {((inputs?: Video_Export_Preview_Go_To_Next_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Next_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_go_to_next_title(inputs)
	if (locale === "de") return de_video_export_preview_go_to_next_title(inputs)
	if (locale === "it") return it_video_export_preview_go_to_next_title(inputs)
	if (locale === "ru") return ru_video_export_preview_go_to_next_title(inputs)
	if (locale === "es") return es_video_export_preview_go_to_next_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_go_to_next_title(inputs)
	if (locale === "ja") return ja_video_export_preview_go_to_next_title(inputs)
	if (locale === "hi") return hi_video_export_preview_go_to_next_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_go_to_next_title(inputs)
	return en_video_export_preview_go_to_next_title(inputs)
});